import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { uiGlobalSelector } from '@/state/ui/global/slices/index.slices'
import useSidebarActions from './use-sidebar-actions.hook'

/**
 * useSidebarUI
 * @description This hook allows control the UI actions in the sidebar (Open & Close Drawer)
 * @returns
 */
const useSidebarUI = () => {
  const location = useLocation()

  const isCurrentPage = (route: string) => {
    return location.pathname === route
  }

  const { isLoadingFull, sidebarStatus } = useSelector(uiGlobalSelector)

  const { setSidebarStatus } = useSidebarActions()

  const ref = useRef<HTMLDivElement>()

  const handleSidebarOpen = () => {
    setSidebarStatus(true)
  }

  const handleSidebarClose = () => {
    setSidebarStatus(false)

    if (ref.current) {
      ref.current.scrollTop = 0
    }
  }

  return {
    ref,
    sidebarStatus,
    isLoadingFull,
    handleSidebarOpen,
    handleSidebarClose,
    isCurrentPage,
  }
}

export default useSidebarUI
